import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";
import MUISnackbar from "material-ui/Snackbar";
import IconButton from "material-ui/IconButton";
import Button from "material-ui/Button";

import CloseIcon from "material-ui-icons/Close";
import { lightGreen } from "material-ui/colors";

const styles = theme => ({
  close: {
    width: theme.spacing.unit * 4,
    height: theme.spacing.unit * 4
  },
  snackbar: {
    margin: "auto",
    marginBottom: theme.spacing.unit * 4,

    maxWidth: 400
  },
  ERROR_NOTIFICATION: {
    color: theme.palette.secondary[400]
  },
  SUCCESS_NOTIFICATION: {
    color: lightGreen[500]
  }
});

const Snackbar = props => {
  const { classes, content, open, onDismiss, showDetails } = props;

  const renderDetailsButton = () => {
    if (open && content.details) {
      return (
        <Button key="details" color="accent" dense onClick={showDetails}>
          DETAILS
        </Button>
      );
    }
  };

  /*
  NOTE: {content.details ? undefined : 4000}
  This use of undefined is currently how material-ui 
  snackbar behaves.
  I made an issue and it will use null in the next version.
  Codacy complains in the meantime: no-undef
  */
  return (
    <MUISnackbar
      className={classes.snackbar}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right"
      }}
      open={open}
      autoHideDuration={content.details ? undefined : 4000}
      message={
        <span>
          <Typography type="body2" className={classes[content.type]}>
            {content.type && content.type.split("_")[0]}
          </Typography>
          <span id="message-id">{content.message}</span>
        </span>
      }
      action={[
        renderDetailsButton(),
        <IconButton
          key="close"
          aria-label="Close"
          color="inherit"
          className={classes.close}
          onClick={onDismiss}
        >
          <CloseIcon />
        </IconButton>
      ]}
    />
  );
};

Snackbar.propTypes = {
  classes: PropTypes.object.isRequired,
  content: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onDismiss: PropTypes.func.isRequired,
  showDetails: PropTypes.func.isRequired
};

export { Snackbar };

export default withStyles(styles, { name: "Snackbar" })(Snackbar);



// WEBPACK FOOTER //
// ./src/Snackbar.js